import { createRouter, createWebHistory } from 'vue-router'

import HomePage from "../Pages/HomePage.vue";
import RegisterPage from "../Pages/RegisterPage.vue";
import PaymentPage from "../Pages/PaymentPage.vue";
import PaymentSuccessPage from "../Pages/PaymentSuccess.vue";
import PaymentFailedPage from "../Pages/PaymentFailed.vue";
import ErrorPage from "../Pages/ErrorPage.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: RegisterPage,
  },
  {
    path: "/payment",
    name: "PaymentPage",
    component: PaymentPage,
  },
  {
    path: "/payment/success",
    name: "PaymentSuccessPage",
    component: PaymentSuccessPage,
  },
  {
    path: "/payment/failed",
    name: "PaymentFailedPage",
    component: PaymentFailedPage,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
})

export default router
